module.exports = __webpack_public_path__ + "static/media/global-shoppng-41.5a924bdf.png";